import {
  BankAccountInfiniteSelectField,
  FloatingFormItem,
  InputDate,
  InputDecimal,
  PlanAccountsSelect,
} from '@/components/_common';
import { PlanAccountType } from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { useAccountReceivableMultipleInstallment } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { useDefaultEmptyFieldError } from '@/hooks';
import useDefaultMinLengthNegativeFieldError from '@/hooks/useDefaultMinLengthNegativeFieldError';
import { Col, Form, Modal, ModalProps, Row } from 'antd';
import moment from 'moment';

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: VoidFunction;
  onFinish: VoidFunction;
  installmentIds: number[];
  accountReceivableIds: number[];
  installmentMinValue?: number;
};

const AccountReceivableMultipleInstallmentModal: React.FC<Props> = ({
  installmentIds,
  accountReceivableIds,
  onFinish,
  installmentMinValue,
  ...props
}) => {
  const [form] = Form.useForm();
  const ruleRequired = useDefaultEmptyFieldError();
  const multipleInstallment = useAccountReceivableMultipleInstallment();
  const defaultMinLengthNegativeFieldError =
    useDefaultMinLengthNegativeFieldError();

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      await multipleInstallment.mutateAsync({
        ...values,
        installmentReceivableId: installmentIds,
        accountReceivableIds: accountReceivableIds,
      });

      onFinish();

      handleClose();
    } catch {}
  }

  function handleClose() {
    props.onCancel();
    form.resetFields();
  }

  return (
    <Modal
      {...props}
      width={500}
      title="Liquidar múltiplas parcelas"
      onCancel={handleClose}
      okText="Liquidar parcelas"
      onOk={handleSubmit}
      confirmLoading={multipleInstallment.isLoading}
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem
              name="bankAccountId"
              label="Conta bancária"
              rules={[ruleRequired]}
            >
              <BankAccountInfiniteSelectField queryFilter={{ active: true }} />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="payDate"
              label="Data de pagamento"
              rules={[ruleRequired]}
              initialValue={moment()}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="planAccountId"
              label="Planos de contas de tarifa"
            >
              <PlanAccountsSelect
                queryFilter={{ type: PlanAccountType.Tariff }}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="discountIncrease"
              label="Acres./Desc."
              rules={[
                defaultMinLengthNegativeFieldError(
                  (installmentMinValue ?? 0) * -1,
                ),
              ]}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AccountReceivableMultipleInstallmentModal;
